/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  PutApiV1PersonIdEmployeeData202,
  PutApiV1PersonIdEmployeeData400,
  PutApiV1PersonIdEmployeeData401,
  PutApiV1PersonIdEmployeeData404,
  PutApiV1PersonIdEmployeeData500,
  PutApiV1PersonIdEmployeeDataMutationRequest,
  PutApiV1PersonIdEmployeeDataMutationResponse,
  PutApiV1PersonIdEmployeeDataPathParams,
} from "../../types/personEmployeeController/PutApiV1PersonIdEmployeeData.ts";
import { personEmployeeDataViewModelSchema } from "../personEmployeeDataViewModelSchema.ts";
import { updateEmployeeDataViewModelSchema } from "../updateEmployeeDataViewModelSchema.ts";

export const putApiV1PersonIdEmployeeDataPathParamsSchema = z.object({
  id: z.coerce.number().int(),
}) as unknown as ToZod<PutApiV1PersonIdEmployeeDataPathParams>;

/**
 * @description (Accepted) Requisição aceita.
 */
export const putApiV1PersonIdEmployeeData202Schema = z.lazy(
  () => personEmployeeDataViewModelSchema,
) as unknown as ToZod<PutApiV1PersonIdEmployeeData202>;

/**
 * @description (Bad Request) Requisição em formato incorreto ou com dados faltantes.
 */
export const putApiV1PersonIdEmployeeData400Schema =
  z.any() as unknown as ToZod<PutApiV1PersonIdEmployeeData400>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const putApiV1PersonIdEmployeeData401Schema =
  z.any() as unknown as ToZod<PutApiV1PersonIdEmployeeData401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const putApiV1PersonIdEmployeeData404Schema =
  z.any() as unknown as ToZod<PutApiV1PersonIdEmployeeData404>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const putApiV1PersonIdEmployeeData500Schema =
  z.any() as unknown as ToZod<PutApiV1PersonIdEmployeeData500>;

export const putApiV1PersonIdEmployeeDataMutationRequestSchema = z.lazy(
  () => updateEmployeeDataViewModelSchema,
) as unknown as ToZod<PutApiV1PersonIdEmployeeDataMutationRequest>;

export const putApiV1PersonIdEmployeeDataMutationResponseSchema = z.lazy(
  () => putApiV1PersonIdEmployeeData202Schema,
) as unknown as ToZod<PutApiV1PersonIdEmployeeDataMutationResponse>;
